module.exports = __webpack_public_path__ + "static/media/Montserrat-Bold.1eaf5953.woff2";